import { Button } from '@bfe/moly';
import { LinkIcon } from '@bfe/moly-icons';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';

const TradingViewAlertEntry = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();

  const gotoSettingTradingviewAlert = () => {
    navigate('/app/user/tradingview-alert');
  };

  return (
    <AccountBasicItem
      icon="account"
      molyIcon={<LinkIcon />}
      text={$t('tradingViewAlert')}
      subText={$t('linkTradingViewToBybit')}
      operation={
        <Button
          size="small"
          data-radius="small"
          variant="primary"
          onClick={gotoSettingTradingviewAlert}
        >
          {$t('View New')}
        </Button>
      }
    />
  );
};

export default TradingViewAlertEntry;
